// src/App.js 
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EventDetailsPage from './pages/EventDetailsPage';
import AboutPage from './pages/AboutPage';
import CreaTuEventoPage from './pages/CreaTuEventoPage';
import MiCuentaPage from './pages/MiCuentaPage';
import Footer from './components/Footer'; // Import the Footer component
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider, useCart } from './context/CartContext';
import CartPage from './pages/CartPage'; // New cart page component
import ResumenPage from './pages/ResumenPage'; // Import ResumenPage
import { OrderProvider } from './context/OrderContext';
import TerminosCondiciones from './pages/TerminosCondiciones';
import PoliticaEntrega from './pages/PoliticaEntrega';
import PoliticaDevoluciones from './pages/PoliticaDevoluciones';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import PoliticaSeguridad from './pages/PoliticaSeguridad';
import GraciasPage from './pages/GraciasPage';
import NewsDetailsPage from './pages/NewsDetailsPage';

import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';


import './App.css';
import './mobile.css';
import MisEventosSponsorPage from './pages/MisEventosSponsorPage';
import DetalleEventoSponsorPage from './pages/DetalleEventoSponsorPage';

function NavBar() {
  const { cart } = useCart();
  const { isLoggedIn, userEmail } = useAuth();
  const cartItemCount = cart.length;

  return (
    <nav className="navbar">
          <ul>
            <li>
              <Link to="/">Inicio</Link>
            </li>
            <li>
              <Link to="/about">Contacto</Link>
            </li>
            <li>
              <Link to="/crea-tu-evento">Crea Tu Evento</Link>
            </li>
            <li>
              <Link to="/mi-cuenta">Mi Cuenta</Link>
            </li>
            <li>
              {isLoggedIn && <span className="user-email">Bienvenido(a), {userEmail}</span>}
            </li>
            <li>
              <Link to="/cart" className="cart-icon">
        🛒      <span className="cart-count">{cartItemCount}</span>
              </Link>
            </li>
          </ul>
        </nav>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <OrderProvider>
    <Router>
      <div>
        {/* Banner Image */}
        <div className="banner">
          <img src="/images/banner.jpg" alt="Santo Domingo Espectáculos" className="banner-image" />
        </div>

        {/* Navigation Menu */}
        
        <NavBar />
        {/* Routes for the Application */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/event/:id" element={<EventDetailsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/crea-tu-evento" element={<CreaTuEventoPage />} />
          <Route path="/mi-cuenta" element={<MiCuentaPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/resumen" element={<ResumenPage />} />
          <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
          <Route path="/politica-entrega" element={<PoliticaEntrega />} />
          <Route path="/politica-devoluciones" element={<PoliticaDevoluciones />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/politica-seguridad" element={<PoliticaSeguridad />} />
          <Route path="/gracias" element={<GraciasPage />} />
          <Route path="/news/:id" element={<NewsDetailsPage />} />
          <Route path="/mis-eventos" element={<MisEventosSponsorPage />} />
          <Route path="/mis-eventos/:eventId" element={<DetalleEventoSponsorPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
          {/* Footer */}
          <Footer />
      </div>
    </Router>
    </OrderProvider>
    </CartProvider>
    </AuthProvider>
  );
}

export default App;
